'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactSkylight = require('react-skylight');

var _reactSkylight2 = _interopRequireDefault(_reactSkylight);

var _components = require('../../components');

require('./DeviceDetailDashboard.css');

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceDetailDashboard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DeviceDetailDashboard, _Component);

  function DeviceDetailDashboard() {
    (0, _classCallCheck3.default)(this, DeviceDetailDashboard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeviceDetailDashboard.__proto__ || (0, _getPrototypeOf2.default)(DeviceDetailDashboard)).call(this));

    _this.state = {
      // Start date for selection
      startDate: null,
      // Content to show in the overlay
      overlayContent: null
    };

    _this.paginatedLoaderRef = null;

    _this.getBasicPaginationQuery = _this.getBasicPaginationQuery.bind(_this);
    _this.getUrlFromQuery = _this.getUrlFromQuery.bind(_this);
    _this.handleDateChange = _this.handleDateChange.bind(_this);
    _this.renderRow = _this.renderRow.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DeviceDetailDashboard, [{
    key: 'getBasicPaginationQuery',
    value: function getBasicPaginationQuery() {
      if (this.props.location.query.sightImages) {
        return '?';
      }
      return '?serial_numbers[]=' + this.props.params.id;
    }
  }, {
    key: 'getUrlFromQuery',
    value: function getUrlFromQuery(query) {
      if (this.props.location.query.sightImages) {
        return '/api/django/cameras/' + this.props.params.id + '/sight_images/' + query;
      }
      return '/api/django/recordings/' + query;
    }
  }, {
    key: 'handleDateChange',
    value: function handleDateChange(date) {
      var loadMorePaginationQuery = '';

      if (date !== null) {
        var dateEpochFormat = date.format();

        var basicQuery = this.getBasicPaginationQuery();
        if (basicQuery !== '?') {
          basicQuery = basicQuery + '&';
        }

        // The query (cursor) to run for the "next page"
        loadMorePaginationQuery = basicQuery + 'start_timestamp=' + dateEpochFormat;
      }

      this.setState({ startDate: date });

      this.paginatedLoaderRef.forceRefresh(loadMorePaginationQuery);
    }

    // Render a single row with the Recording Detail object

  }, {
    key: 'renderRow',
    value: function renderRow(_ref) {
      var _this2 = this;

      var key = _ref.key,
          style = _ref.style,
          object = _ref.object;

      var showOverlay = function showOverlay(overlayContent) {
        // console.log(overlayContent);
        _this2.setState({ overlayContent: overlayContent }, function () {
          _this2.simpleDialog.show();
        });
      };

      var detailObject = null;

      if (this.props.location.query.sightImages && object) {
        detailObject = _react2.default.createElement(_components.SightImagesDetail, { sightImage: object });
      } else if (object) {
        detailObject = _react2.default.createElement(_components.RecordingDetail, { recording: object, showOverlay: showOverlay });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: style },
        detailObject
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'Camera: ',
          this.props.params.id
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'Dashboard' }),
        _react2.default.createElement(
          _reactSkylight2.default,
          {
            hideOnOverlayClicked: true,
            ref: function ref(_ref2) {
              _this3.simpleDialog = _ref2;
            },
            afterClose: function afterClose() {
              return _this3.setState({ overlayContent: null });
            },
            dialogStyles: { marginTop: '-300px', marginLeft: '-457px' },
            title: 'Recording Playback'
          },
          this.state.overlayContent
        ),
        _react2.default.createElement(_reactDatepicker2.default, {
          utcOffset: 0,
          dateFormat: 'DD-MMM HH:mm',
          onChange: this.handleDateChange,
          showTimeSelect: true,
          selected: this.state.startDate,
          timeFormat: 'HH:mm',
          timeIntervals: 15,
          isClearable: true,
          minDate: (0, _moment2.default)().subtract(35, 'days'),
          maxDate: (0, _moment2.default)(),
          todayButton: 'Using the customers timezone',
          placeholderText: 'Select to choose date'
        }),
        _react2.default.createElement(_components.PaginatedLoader, {
          ref: function ref(child) {
            _this3.paginatedLoaderRef = child;
          },
          rowHeight: this.props.rowHeight,
          renderRow: this.renderRow,
          getEmptyPaginationQuery: this.getBasicPaginationQuery,
          getUrlFromQuery: this.getUrlFromQuery
        })
      );
    }
  }]);
  return DeviceDetailDashboard;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object,
  location: _react.PropTypes.object,
  rowHeight: _react.PropTypes.number
}, _class.defaultProps = {
  rowHeight: 250
}, _temp);
exports.default = DeviceDetailDashboard;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/DeviceDetailDashboard/DeviceDetailDashboard.js
 ** module id = 1395
 ** module chunks = 0
 **/